import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import {
  BigValueRendererComponent,
  ChartOptionsMenuComponent,
  FieldTreeViewComponent,
  InPlaceTextareaComponent,
  InPlaceInputComponent,
  TableRendererComponent,
  VizLoaderComponent,
  VizRendererComponent,
  VisualizationMenuComponent,
} from '@mode/charts/ui';

export const DowngradedChartsUIModule = angular
  .module('downgraded-charts-ui', [])
  .directive('modeBigValueRenderer', downgradeComponent({ component: BigValueRendererComponent }))
  .directive('modeFieldTreeView', downgradeComponent({ component: FieldTreeViewComponent }))
  .directive('modeTableRenderer', downgradeComponent({ component: TableRendererComponent }))
  .directive('modeVisualizationMenu', downgradeComponent({ component: VisualizationMenuComponent }))
  .directive('modeChartOptionsMenu', downgradeComponent({ component: ChartOptionsMenuComponent }))
  .directive('modeInPlaceInput', downgradeComponent({ component: InPlaceInputComponent }))
  .directive('modeInPlaceTextarea', downgradeComponent({ component: InPlaceTextareaComponent }))
  .directive('modeVizLoader', downgradeComponent({ component: VizLoaderComponent }))
  .directive('modeVizRenderer', downgradeComponent({ component: VizRendererComponent })).name;
